/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { Divider } from "@material-ui/core";
import "../TaskList/styles/TaskFilter.css";

import LessonPlans from "./LessonPlans/LessonPlans";
import { LessonPlanAPIs } from "./api";
import { getUserProfile } from "../auth/Auth";
import { readCookie } from "../Functions/Cookies";

const LessonPlansPage = () => {
  document.title = "2xcell.in";
  const [selectedGrades, setSelectedGrades] = useState({});
  const [selectedTeacher, setSelectedTeacher] = useState(null);
  const [lessonPlans, setLessonPlans] = useState([]);
  const [grades, setGrades] = useState({});
  const [loading, setLoading] = useState(false);
  const [filterDateObject, setFilterDate] = useState({
    fromDate: null,
    toDate: null,
  });

  // filter data handle
  const handleDateChange = (e) => {
    const { name, value } = e.target;

    // Ensure the value is in YYYY-MM-DD format
    const formattedDate = value
      ? new Date(value).toISOString().split("T")[0]
      : null; // '2025-05-01'

    setFilterDate((prev) => ({
      ...prev,
      [name]: formattedDate,
    }));
  };

  const userDetails = getUserProfile();

  function selectGrade(event) {
    const gradeId = event.target.value;
    if (!gradeId) {
      setSelectedGrades({});
      return;
    }
    const select = {};
    if (select[gradeId]) {
      delete select[gradeId];
    } else {
      select[gradeId] = [];
    }
    setSelectedGrades({ ...select });
  }

  function selectSubject(event) {
    const [gradeId, subjectId] = (event.target.value || "").split("-");
    console.log(gradeId, subjectId);
    if (subjectId && selectedGrades[gradeId].includes(subjectId)) {
      selectedGrades[gradeId] = selectedGrades[gradeId].filter(
        (id) => id !== subjectId
      );
    } else {
      selectedGrades[Object.keys(selectedGrades)[0]] = subjectId
        ? [subjectId]
        : [];
    }
    setSelectedGrades({ ...selectedGrades });
  }

  const filterObjects = useMemo(() => {
    const gradeMap = new Map();
    const teacherMap = new Map();

    lessonPlans.forEach((item) => {
      const { sectionId, subjectId, teacherId } = item;

      if (
        !sectionId ||
        !sectionId._id ||
        !subjectId ||
        !subjectId._id ||
        !teacherId?._id
      )
        return;

      // Create subject object
      const subjectObj = {
        name: subjectId.name,
        value: subjectId._id,
        section: `${sectionId?.grade || ""}-${sectionId?.section || ""}`,
        sectionId: sectionId?._id || "",
      };

      // Add grade with nested subject
      if (!gradeMap.has(sectionId._id)) {
        gradeMap.set(sectionId._id, {
          name: `${sectionId.grade}-${sectionId.section}`,
          value: sectionId._id,
          subjects: [subjectObj],
        });
      } else {
        const grade = gradeMap.get(sectionId._id);
        const existingSubject = grade.subjects.find(
          (sub) => sub.value === subjectId._id
        );
        if (!existingSubject) {
          grade.subjects.push(subjectObj);
        }
      }

      if (!teacherMap.has(teacherId?._id) && userDetails?.role !== "teacher") {
        teacherMap.set(teacherId._id, {
          name: teacherId?.name,
          value: teacherId?._id,
        });
      }
    });

    return {
      grades: Array.from(gradeMap.values()),
      teachers: Array.from(teacherMap.values()),
    };
  }, [lessonPlans]);

  const filterSubjects = useMemo(() => {
    return filterObjects.grades
      .filter((grade) => {
        return Object.keys(selectedGrades).includes(grade.value);
      })
      .map((grade) => {
        return grade.subjects;
      })
      .flat(1);
  }, [selectedGrades, filterObjects]);

  async function fetchLessonPlans() {
    console.log("Fetch plan");
    if (loading) return;
    setLoading(true);
    //fetch lesson plans
    await axios
      .get(
        `${LessonPlanAPIs.fetchLessonPlans(
          userDetails.userId
        )}?sort=-startDate,_id`,
        {
          headers: {
            token: readCookie("token"),
          },
          validateStatus: () => true,
        }
      )
      .then((res) => {
        if (res.data.status !== "success") throw res.data;
        setLessonPlans(res.data.data.lessonPlans);
      })
      .catch((err) => {
        alert(err.message);
        console.log(err.message);
      })
      .finally(() => setLoading(false));
  }

  function clearFilter() {
    setFilterDate({ fromDate: null, toDate: null });
    setSelectedGrades({});
    setSelectedTeacher(null);
  }

  const filteredPlans = useMemo(() => {
    return lessonPlans.filter((lp) => {
      if (selectedTeacher && lp?.teacherId?._id !== selectedTeacher)
        return false;
      // --- DATE FILTER ---
      if (filterDateObject?.fromDate || filterDateObject?.toDate) {
        const createdAt = new Date(lp.startDate);
        const from = filterDateObject.fromDate
          ? new Date(filterDateObject.fromDate)
          : null;
        const to = filterDateObject.toDate
          ? new Date(filterDateObject.toDate)
          : null;

        if (from && to) {
          if (createdAt < from || createdAt > to) return false;
        } else if (from) {
          if (createdAt < from) return false;
        } else if (to) {
          if (createdAt > to) return false;
        }
      }

      if (!Object.keys(selectedGrades).length) return true; //Show all rows
      if (selectedGrades[lp?.sectionId?._id]) {
        if (!selectedGrades[lp?.sectionId?._id].length) return true; //Show all subjects of selected class
        if (selectedGrades[lp?.sectionId?._id].includes(lp.subjectId?._id))
          return true; //show only selected subject of selected grade
        return false;
      }
      return false;
    });
  }, [selectedGrades, selectedTeacher, lessonPlans, filterDateObject]);

  useEffect(() => {
    fetchLessonPlans();
  }, []);

  return (
    <>
      <section className="lesson-plans">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <h1 style={{ margin: "0" }}>Lesson Plans</h1>
        </div>
        <div className="lesson-plan-content">
          {filterObjects?.grades.length ? (
              <div className="lesson-plan-filter">
                  <div className="class px-3 mt-2 lp-input">
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        color: "#4fb8ad",
                      }}
                    >
                      TEACHERS
                    </p>
                    {filterObjects?.teachers && filterObjects.teachers.length && (
                      <select
                        className="select"
                        onChange={(e) =>
                          setSelectedTeacher(e.target.value || "")
                        }
                        value={selectedTeacher || ""}
                      >
                        <option key={0} value={""}>
                          Select Teacher
                        </option>
                        {filterObjects.teachers.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>

                  <div className="class px-3 mt-2 lp-input">
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        color: "#4fb8ad",
                      }}
                    >
                      GRADES
                    </p>
                    {filterObjects?.grades && (
                      <select
                        className="select"
                        value={Object.keys(selectedGrades)[0] || ""}
                        onChange={selectGrade}
                      >
                        <option key={0} value={""}>
                          Select Grade
                        </option>
                        {filterObjects.grades.map((item, index) => (
                          <option key={index} value={item.value}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    )}
                  </div>
                  {filterSubjects.length ? (
                    <>
                      <div className="subjects px-3 mt-2 lp-input">
                        <p
                          style={{
                            margin: 0,
                            fontWeight: "bold",
                            color: "#4fb8ad",
                          }}
                        >
                          SUBJECT
                        </p>
                        <select className="select" onChange={selectSubject}>
                          <option key={0} value={""}>
                            Select Subject
                          </option>
                          {filterSubjects.map((item, index) => (
                            <option
                              key={index}
                              value={`${item.sectionId}-${item.value}`}
                              selected={selectedGrades[item.sectionId].includes(
                                item.value
                              )}
                            >
                              {item.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}

                  <div className="subjects px-3 mt-2 lp-input">
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        color: "#4fb8ad",
                      }}
                    >
                      From Date
                    </p>
                    <input
                      name="fromDate"
                      type="date"
                      value={filterDateObject.fromDate || ""}
                      onChange={handleDateChange}
                    />
                  </div>

                  <div className="subjects px-3 mt-2 lp-input">
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        color: "#4fb8ad",
                      }}
                    >
                      To Date
                    </p>
                    <input
                      name="toDate"
                      type="date"
                      value={filterDateObject.toDate || ""}
                      onChange={handleDateChange}
                    />
                  </div>

                  <div
                    style={{
                      width: "calc(100% - 24px)",
                      height: "35px",
                      marginTop: "auto",
                      borderRadius: "5px",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "0.9rem",
                      cursor: "pointer",
                      border: "2px solid #4fb8ad",
                      cursor: "pointer",
                      justifyContent: "center",
                      color: "#4fb8ad",
                    }}
                    onClick={clearFilter}
                  >
                    <span style={{ display: "block" }}>Clear Filter</span>
                  </div>
                </div>
          ) : (
            <></>
          )}
          <LessonPlans
            staffRole={userDetails?.role || ""}
            loading={loading}
            grades={filterObjects.grades.length}
            lessonPlans={filteredPlans || []}
            filterDateObject={filterDateObject}
            handleDateChange={handleDateChange}
            setLessonPlans={setLessonPlans}
            clearFilter={clearFilter}
          />
        </div>
      </section>
    </>
  );
};

export default LessonPlansPage;
